import React, { useEffect, useState } from "react";
import api from "../api";
import axios from "axios";
import {
  Backdrop,
  Card,
  CircularProgress,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
  FormControl,
  FormControlLabel,
  Checkbox,
  Link,
  Dialog,
  DialogTitle,
  DialogContent
} from "@material-ui/core";
import {
  Button,
  CardBody,
  CardHeader,
  Col,
  FormSelect,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  ListGroup,
  ListGroupItem,
  Row
} from "shards-react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Autocomplete } from "@material-ui/lab";
import NumberFormat from "react-number-format";
import MediaFile from "../MediaFile";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import PersonAddDisabledIcon from "@material-ui/icons/PersonAddDisabled";
import InfoAuto from "../../vehicles/InfoAuto/InfoAuto";
import { userHasRole } from "../../auth/UserFunctions";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const InfoAutoDialog = ({ version, model }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Typography
        variant="button"
        className="mt-2 ml-2"
        onClick={() => setOpen(!open)}
        style={{
          cursor: "pointer",
          textDecoration: "underline",
          display: "inline-block",
          fontSize: "12px"
        }}
      >
        Ficha InfoAuto{" "}
      </Typography>
      <Dialog
        PaperProps={{
          style: {
            width: "900px",
            maxWidth: "900px"
          }
        }}
        open={open}
        fullWidth
        aria-labelledby="responsive-dialog-title"
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogTitle id="responsive-dialog-title">
          {"Ficha InfoAuto"}
        </DialogTitle>
        <DialogContent style={{ width: "900px" }}>
          <InfoAuto variation={model} version={version} />
        </DialogContent>
      </Dialog>
    </>
  );
};

const Booking = ({ id }) => {
  const [clients, setClients] = useState({
    options: [],
    loading: false
  });
  const [versions, setVersions] = useState({
    options: [],
    loading: false
  });
  const [selectedVersion, setSelectedVersion] = useState(null);

  const [showNewContact, setShowNewContact] = useState(false);
  const [subcontacts, setSubcotacts] = useState([]);
  const [vehicles, setVehicles] = useState({
    options: [],
    loading: false
  });

  const bookingTypes = [
    {
      id: 1,
      name: "Flex"
    },
    {
      id: 2,
      name: "Renting"
    }
  ];

  const billingPeriods = ["Mensual", "Diario"];
  const qMonths = [
    { id: 1, name: "1 mes", months: 1 },
    { id: 2, name: "2 meses", months: 2 },
    { id: 3, name: "3 meses", months: 3 },
    { id: 4, name: "4 meses", months: 4 },
    { id: 5, name: "5 meses", months: 5 },
    { id: 6, name: "6 meses", months: 6 },
    { id: 7, name: "7 meses", months: 7 },
    { id: 8, name: "8 meses", months: 8 },
    { id: 9, name: "9 meses", months: 9 },
    { id: 10, name: "10 meses", months: 10 },
    { id: 11, name: "11 meses", months: 11 },
    { id: 12, name: "12 meses", months: 12 }
  ];
  const relationTypes = ["hereda", "relacionada"];
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [snackbar, setSnackbar] = useState({
    message: "",
    open: false,
    severity: "success"
  });
  const [backdrop, setBackdrop] = useState({
    open: false,
    message: "Guardando..."
  });
  const [clientStructures, setClientStructures] = useState([]);
  const [clientContracts, setClientContracts] = useState([]);
  const [booking, setBooking] = useState({
    status: "",
    start_date: "",
    end_date: "",
    type: { description: "" },
    plate: { plate: "", description: "" },
    relatedPlate: { plate: "" },
    relations: [],
    id: id,
    assign_any: true,
    subcontact: {},
    can_change_plate: true,
    change_plate: false
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [searchByPlate, setSearchByPlate] = useState(true);
  const [showBookingWorkOrders, setShowBookingWorkOrders] = useState(false);
  const [showBookingHistory, setShowBookingHistory] = useState(false);
  const [showBookingAttachments, setShowBookingAttachments] = useState(false);
  const [showBookingRelations, setShowBookingRelations] = useState(false);
  const [showBookingBillings, setShowBookingBillings] = useState(false);
  const [showBookingTelepaseTolls, setShowBookingTelepaseTolls] = useState(false);
  const [bookingTelepaseTolls, setBookingTelepaseTolls] = useState([]);
  const [workOrderTypes, setWorkOrderTypes] = useState([]);
  const [workOrderType, setWorkOrderType] = useState("");
  const [relatedBooking, setRelatedBooking] = useState({
    related_booking_id: "",
    type: ""
  });
  const [fileAttached, setFileAttached] = useState(null);
  const [qAvailable, setQAvailable] = useState(0);

  useEffect(() => {
    const getData = async () => {
      await getDefaultFranchise();
      if (id > 0) await getBooking(id);

      getVehicleTypes();
      getWorkOrderTypes().then(() => {
        if (id == 0) setLoading(false);
      });
    };
    getData();
  }, [id]);

  useEffect(() => {
    if (booking.client_id) {
      getClientStructures();
      getContracts();
    }
  }, [booking.client_id]);

  useEffect(() => {
    if (booking.vehicle_id) {
      getVehicle(booking.vehicle_id);
    }
  }, [booking.vehicle_id]);

  const getVehicleTypes = async () => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.vehicle_types, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setVehicleTypes(res.data);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const getDefaultFranchise = async () => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.defaultFranchise, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        if (res.data) {
          setBooking({
            ...booking,
            franchise: res.data
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  const getVehicle = async vehicle_id => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.vehicles().get(vehicle_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        if (res.data && res.data[0]) {
          setBooking({
            ...booking,
            plate: res.data[0]
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const getClientStructures = async () => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.clients().get(booking.client_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        if (res.data && res.data[0]) setClientStructures(res.data[0].structure);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const getContracts = async () => {
    const token = localStorage.getItem("userToken");
    var url = api.contracts;
    url += "?client_id=" + booking.client_id;
    url += "&type_id=2";
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        if (res.data && res.data[0]) setClientContracts(res.data);
      })
      .catch(err => {
        console.log(err);
      });
  };
  const getWorkOrderTypes = async () => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.dropdowns().ot(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setWorkOrderTypes(res.data.work_order_types);
      })
      .catch(err => {
        console.log(err);
      });
  };
  const handleSearchVersions = async (search, callback) => {
    var value = callback;
    const token = localStorage.getItem("userToken");
    if (value.length > 2) {
      return axios
        .get(api.versions().autocomplete(value), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          setVersions({
            options: res.data,
            loading: false
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };
  const getVersion = async id => {
    const token = localStorage.getItem("userToken");
    if (id > 0) {
      axios
        .get(api.versions().get(id), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          if (res.data && res.data[0]) {
            const version = res.data[0].versions.filter(v => v.id == id);
            if (version.length > 0) {
              const r = version[0];
              // unset versions in res.data[0]
              delete res.data[0].versions;
              r.variation = res.data[0];
              setSelectedVersion(r);
            }
          }
        });
    }
  };
  const handleClientSearch = async (search, callback) => {
    var value = callback;
    const token = localStorage.getItem("userToken");
    if (value.length > 2) {
      return axios
        .get(api.clients().autocomplete(value), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          setClients({
            options: res.data,
            loading: false
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };
  const handleVehicleSearch = async (search, callback) => {
    var value = callback;
    const token = localStorage.getItem("userToken");
    if (value.length > 2) {
      let url = api.vehicles().indexAc(1, value);
      if (!searchByPlate) {
        url = api.vehicles().indexAc(1, "", value);
      }
      return axios
        .get(url, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          setVehicles({
            options: res.data,
            loading: false
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  const handleRelatedVehicleSearch = async (search, callback) => {
    var value = callback;
    const token = localStorage.getItem("userToken");
    if (value.length > 2) {
      let url = api.vehicles().indexAc(0, value);
      url += `&related=1`;
      return axios
        .get(url, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          setVehicles({
            options: res.data,
            loading: false
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  const getBooking = async id => {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.bookings().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(async res => {
        if (res.data) {
          if (
            res.data.assign_any == "true" ||
            res.data.assign_any == true ||
            res.data.assign_any == 1
          ) {
            res.data.assign_any = true;
          }
        }
        if (!res.data.plate) res.data.plate = { plate: "", description: "" };
        setBooking(res.data);
        if (
          res.data.client &&
          res.data.client.contact &&
          res.data.client.contact.subcontacts
        ) {
          setSubcotacts(res.data.client.contact.subcontacts);
        }
        if (res.data.client && res.data.client.structure) {
          setClientStructures(res.data.client.structure);
        }
        if (res.data.relatedPlate) {
          setVehicles({
            options: [res.data.relatedPlate],
            loading: false
          });
        }
        if (res.data.telepase_tolls){
          const telepase_tolls_grouped = res.data.telepase_tolls.reduce((acc, curr) => {
            const date = new Date(curr.date.split('/').reverse().join('-'));
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            const key = `${year}-${month}`;
            if (!acc[key]) {
              acc[key] = 0;
            }
            acc[key] += parseFloat(curr.amount);
            return acc;
          }, {});
          setBookingTelepaseTolls(telepase_tolls_grouped);
        }
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleCreateRelation = async () => {
    setBackdrop({ open: true, message: "Creando relación..." });

    const token = localStorage.getItem("userToken");
    const formData = new FormData();
    formData.append("booking[id]", booking.id);
    formData.append(
      "booking[related_booking_id]",
      relatedBooking.related_booking_id
    );
    formData.append("booking[type]", relatedBooking.type);
    return axios
      .post(api.bookings().createRelation(), formData, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setSnackbar({
          open: true,
          message: "Relación creada con exito",
          severity: "success"
        });
        getBooking(booking.id);
        setBackdrop({ open: false, message: "" });
      })
      .catch(err => {
        // get errors from err
        const { errors } = err.response.data;
        let error_msg = "";
        if (errors) {
          for (let key in errors) {
            error_msg += errors[key];
          }
          setSnackbar({
            open: true,
            message: error_msg,
            severity: "error"
          });
        } else {
          setSnackbar({
            open: true,
            message: "Ha ocurrido un error al crear la relación",
            severity: "error"
          });
        }
        setBackdrop({ open: false, message: "" });
      });
  };

  const handleCreateWorkOrder = async () => {
    if (!workOrderType) {
      setSnackbar({
        open: true,
        message: "Seleccione un tipo de orden de trabajo",
        severity: "warning"
      });
      return;
    }
    const token = localStorage.getItem("userToken");
    const formData = new FormData();
    formData.append("booking[id]", booking.id);
    formData.append("type", workOrderType);
    return axios
      .post(api.bookings().createWorkOrder(), formData, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setSnackbar({
          open: true,
          message: "Orden de trabajo creada con exito",
          severity: "success"
        });
        getBooking(booking.id);
      })
      .catch(err => {
        setSnackbar({
          open: true,
          message: "Ha ocurrido un error al crear la orden de trabajo",
          severity: "error"
        });
        setBackdrop({ open: false, message: "" });
      });
  };
  const doTransition = async transition => {
    setBackdrop({ open: true, message: "Cambiando estado..." });
    setSaving(true);
    const token = localStorage.getItem("userToken");
    const formData = new FormData();
    formData.append("booking[id]", booking.id ? booking.id : "");
    formData.append("transition", transition);
    formData.append("_method", "PATCH");
    return axios
      .post(api.bookings().transition(booking.id), formData, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setSnackbar({
          open: true,
          message: "Cambio de estado de la reserva con exito",
          severity: "success"
        });
        setSaving(false);
        setBooking({
          ...booking,
          transitions: []
        });
        setBackdrop({ open: true, message: "Refrescando reserva..." });
        getBooking(booking.id).then(setBackdrop({ open: false, message: "" }));
        setSaving(false);
      })
      .catch(err => {
        const { errors } = err.response.data;
        let error_msg = "";
        if (errors) {
          for (let key in errors) {
            error_msg += errors[key];
          }
          setSnackbar({
            open: true,
            message: error_msg,
            severity: "error"
          });
        } else {
          setSnackbar({
            open: true,
            message: "Ha ocurrido un error al guardar la reserva",
            severity: "error"
          });
        }
        setBackdrop({ open: false, message: "" });
        setSaving(false);
      });
  };

  const handleUploadFile = async file => {
    setFileAttached(file);
  };

  const handleExport = async () => {
    setBackdrop({ open: true, message: "Exportando..." });
    const token = localStorage.getItem("userToken");
    axios
      .get(api.bookings().exportBooking(booking.id), {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob"
      })
      .then(response => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "Reserva_" + booking.id + ".pdf"); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
        setBackdrop({ open: false, message: "" });
      })
      .catch(function(error) {
        console.log(error);
        setBackdrop({ open: false, message: "" });
      });
  };
  const handleSubmit = async () => {
    setBackdrop({ open: true, message: "Guardando..." });

    const token = localStorage.getItem("userToken");
    const formData = new FormData();
    formData.append(
      "booking[booking_type_id]",
      booking.type ? booking.type.id : ""
    );
    formData.append(
      "booking[description]",
      booking.description ? booking.description : ""
    );
    formData.append(
      "booking[purchase_order]",
      booking.purchase_order ? booking.purchase_order : ""
    );
    formData.append(
      "booking[vehicle_id]",
      booking.vehicle_id ? booking.vehicle_id : ""
    );
    formData.append(
      "booking[vehicle_type_id]",
      booking.vehicle_type_id ? booking.vehicle_type_id : ""
    );
    formData.append(
      "booking[version_id]",
      booking.version_id ? booking.version_id : ""
    );
    formData.append(
      "booking[related_vehicle_id]",
      booking.related_vehicle_id ? booking.related_vehicle_id : ""
    );
    formData.append(
      "booking[client_id]",
      booking.client_id ? booking.client_id : ""
    );
    formData.append(
      "booking[client_structure_id]",
      booking.client_structure_id ? booking.client_structure_id : ""
    );
    formData.append(
      "booking[subcontact_id]",
      booking.subcontact_id ? booking.subcontact_id : ""
    );
    formData.append(
      "booking[contact_document_number]",
      booking.contact_document_number ? booking.contact_document_number : ""
    );

    formData.append(
      "booking[contract_id]",
      booking.contract_id ? booking.contract_id : ""
    );
    formData.append(
      "booking[initial_km]",
      booking.initial_km ? booking.initial_km : ""
    );
    formData.append("booking[last_km]", booking.last_km ? booking.last_km : "");
    formData.append(
      "booking[start_date]",
      booking.start_date ? booking.start_date : ""
    );
    formData.append(
      "booking[end_date]",
      booking.end_date ? booking.end_date : ""
    );
    formData.append(
      "booking[expected_pickup_date]",
      booking.expected_pickup_date ? booking.expected_pickup_date : ""
    );
    formData.append(
      "booking[expected_dropoff_date]",
      booking.expected_dropoff_date ? booking.expected_dropoff_date : ""
    );
    formData.append(
      "booking[actual_pickup_date]",
      booking.actual_pickup_date ? booking.actual_pickup_date : ""
    );
    formData.append(
      "booking[actual_dropoff_date]",
      booking.actual_dropoff_date ? booking.actual_dropoff_date : ""
    );
    formData.append(
      "booking[km_price]",
      booking.km_price ? booking.km_price : ""
    );
    formData.append(
      "booking[toll_price]",
      booking.toll_price ? booking.toll_price : ""
    );

    formData.append(
      "booking[q_km_included]",
      booking.q_km_included ? booking.q_km_included : ""
    );
    formData.append(
      "booking[extra_km_price]",
      booking.extra_km_price ? booking.extra_km_price : ""
    );
    formData.append(
      "booking[extras_price]",
      booking.extras_price ? booking.extras_price : ""
    );
    formData.append(
      "booking[total_price]",
      booking.total_price ? booking.total_price : ""
    );
    formData.append(
      "booking[franchise]",
      booking.franchise ? booking.franchise : ""
    );
    formData.append(
      "booking[billing_period]",
      booking.billing_period ? booking.billing_period : ""
    );
    formData.append("booking[assign_any]", booking.assign_any ? 1 : 0);
    formData.append(
      "booking[purche_order]",
      booking.purchaze_order ? booking.purchase_order : ""
    );
    if (fileAttached) {
      formData.append("media[0][file]", fileAttached[0]);
    }
    if (booking.id == 0 && showNewContact) {
      formData.append("booking[subcontact_new]", 1);
      formData.append(
        "subcontact[firstname]",
        booking.subcontact.firstname ? booking.subcontact.firstname : ""
      );
      formData.append(
        "subcontact[lastname]",
        booking.subcontact.lastname ? booking.subcontact.lastname : ""
      );
      formData.append(
        "subcontact[email]",
        booking.subcontact.email ? booking.subcontact.email : ""
      );
      formData.append(
        "subcontact[phone]",
        booking.subcontact.phone ? booking.subcontact.phone : ""
      );
    }
    let url = api.bookings().post();
    if (booking.id > 0) {
      formData.append("booking[id]", booking.id);
      formData.append("_method", "PATCH");
      url = api.bookings().patch(booking.id);
    }
    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        if (booking.id > 0) {
          setSnackbar({
            open: true,
            message: "Reserva guardada con exito",
            severity: "success"
          });
          setBackdrop({ message: "Refrescando reserva..." });
          getBooking(booking.id).then(setBackdrop({ open: false }));
          return;
        } else {
          const { data } = res;
          const { booking } = data;
          window.location.href = `/booking/${booking.id}`;
        }
      })
      .catch(err => {
        const { errors } = err.response.data;
        let error_msg = "";
        if (errors) {
          for (let key in errors) {
            error_msg += errors[key];
          }
          setSnackbar({
            open: true,
            message: error_msg,
            severity: "error"
          });
        } else {
          setSnackbar({
            open: true,
            message: "Ha ocurrido un error al guardar la reserva",
            severity: "error"
          });
        }
        setBackdrop({ open: false, message: "" });
      });
  };

  if (loading)
    return (
      <Row>
        <Col lg={12}>
          <CircularProgress />
        </Col>
      </Row>
    );
  return (
    <>
      <Snackbar
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        className="alert-fix"
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Backdrop
        open={backdrop.open}
        onClick={() => setBackdrop({ open: false, message: "" })}
        style={{ zIndex: 10000, color: "#3f51b5" }}
      >
        <Typography className="ml-2" variant="h5" color="primary">
          {backdrop.message}
        </Typography>
      </Backdrop>
      <Typography variant="h6">
        {id == 0
          ? "Nueva Reserva"
          : "Reserva " + id + "(" + booking.hansa_code + ")"}
      </Typography>
      <Row className="px-2">
        <Col lg={booking.id == 0 ? 12 : 9}>
          <Row className="px-2">
            <TextField
              id="booking_type_id"
              name="booking_type_id"
              select
              margin="normal"
              className="mt-2 col-md-3"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setBooking({
                  ...booking,
                  booking_type_id: e.target.value,
                  type: bookingTypes.find(type => type.id == e.target.value)
                });
              }}
              value={booking.booking_type_id}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Tipo de Reserva</Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            >
              {bookingTypes.map(option => (
                <MenuItem
                  key={option.id}
                  value={option.id}
                  style={{ fontSize: "0.75rem" }}
                  on
                >
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            {booking.id == 0 || booking.change_plate ? (
              <>
                {!searchByPlate && (
                  <>
                    <TextField
                      id="vehicle_type_id"
                      name="vehicle_type_id"
                      select
                      margin="normal"
                      className="mt-2 ml-2 col-md-3"
                      InputLabelProps={{
                        shrink: true
                      }}
                      onChange={e => {
                        setBooking({
                          ...booking,
                          vehicle_type_id: e.target.value
                        });
                        const vehicleType = vehicleTypes.find(
                          type => type.id == e.target.value
                        );
                        setQAvailable(vehicleType.q_available);
                      }}
                      value={booking.vehicle_type_id}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography variant="caption">
                              Tipo de vehículo
                            </Typography>
                          </InputAdornment>
                        ),
                        style: { fontSize: "0.75rem" }
                      }}
                    >
                      {vehicleTypes.map(option => (
                        <MenuItem
                          key={option.id}
                          value={option.id}
                          style={{ fontSize: "0.75rem" }}
                        >
                          {option.name} {option.hansa_description} (
                          {option.q_available} disponibles)
                        </MenuItem>
                      ))}
                    </TextField>
                    <Autocomplete
                      id={"versions"}
                      name={"versions"}
                      getOptionLabel={option => option.full_name}
                      getOptionSelected={(option, value) =>
                        option.full_name === value
                      }
                      options={versions.options}
                      loading={versions.loading}
                      onInputChange={handleSearchVersions}
                      renderOption={option => (
                        <Typography variant="caption">
                          {option.full_name}({option.q_available} disponibles)
                        </Typography>
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setBooking({
                            ...booking,
                            version_id: value.id
                          });
                          setQAvailable(value.q_available);

                          getVersion(value.id);
                        }
                      }}
                      noOptionsText={
                        <Typography variant="caption">
                          {versions.loading ? "Buscando" : "Sin resultados"}
                        </Typography>
                      }
                      includeInputInList
                      className="mt-2 mr-2 col-md-3"
                      renderInput={params => (
                        <TextField
                          {...params}
                          placeholder="Ingrese una version"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {versions.loading ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            )
                          }}
                          InputLabelProps={{
                            ...params.InputLabelProps,
                            shrink: true
                          }}
                          inputProps={{
                            ...params.inputProps,
                            style: { fontSize: "0.75rem", width: 230 }
                          }}
                        />
                      )}
                    />
                  </>
                )}
                {searchByPlate && (
                  <Autocomplete
                    id={"vehicles"}
                    name={"vehicles"}
                    getOptionLabel={option => option.plate}
                    getOptionSelected={(option, value) =>
                      option.plate === value
                    }
                    options={vehicles.options}
                    loading={vehicles.loading}
                    onInputChange={handleVehicleSearch}
                    onChange={(e, value) => {
                      if (value) {
                        setBooking({
                          ...booking,
                          vehicle_id: value.id,
                          initial_km: value.last_km
                        });
                      }
                    }}
                    renderOption={option => (
                      <Typography variant="caption">
                        {option.plate} {option.description}
                        {option.version.vehicle_type
                          ? "(" +
                            option.version.vehicle_type.hansa_description +
                            " - " +
                            option.version.vehicle_type.hansa_code +
                            ")"
                          : ""}
                      </Typography>
                    )}
                    autoComplete
                    noOptionsText={
                      <Typography variant="caption">Sin resultados</Typography>
                    }
                    includeInputInList
                    className="mt-2 col-md-3"
                    renderInput={params => (
                      <TextField
                        {...params}
                        placeholder={
                          searchByPlate
                            ? `Ingrese una patente`
                            : `Ingrese por tipo de renting o marca modelo`
                        }
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {vehicles.loading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          )
                        }}
                        InputLabelProps={{
                          ...params.InputLabelProps,
                          shrink: true
                        }}
                        inputProps={{
                          ...params.inputProps,
                          style: { fontSize: "0.75rem", width: 100 }
                        }}
                      />
                    )}
                  />
                )}
                {booking.id == 0 && (
                  <Button
                    outline
                    theme="accent"
                    style={{ height: "fit-content", padding: "0.5rem" }}
                    size="sm"
                    onClick={() => setSearchByPlate(!searchByPlate)}
                  >
                    <i className="material-icons">search</i>{" "}
                    {searchByPlate ? "Por tipo" : "Por patente"}
                  </Button>
                )}
              </>
            ) : (
              <TextField
                id="plate.plate"
                name="plate.plate"
                margin="normal"
                disabled
                className="mt-2 col-md-2"
                InputLabelProps={{
                  shrink: true
                }}
                value={booking.plate.plate}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Vehículo</Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              />
            )}
            <FormControlLabel
              control={
                <Checkbox
                  name={"assign_any"}
                  disabled={booking.can_change_plate ? false : true}
                  id={"assign_any"}
                  checked={booking.assign_any ? true : false}
                  value={booking.assign_any ? true : false}
                  onChange={e => {
                    setBooking({
                      ...booking,
                      assign_any: e.target.checked
                    });
                  }}
                />
              }
              label={
                <Typography variant="caption">
                  Asignar por disponibilidad
                </Typography>
              }
              labelPlacement="start"
            />
            <Typography
              variant="caption"
              className="ml-2 mt-3"
              style={{ fontSize: "0.75rem" }}
            >
              {qAvailable > 0
                ? "Vehículos disponibles: " + qAvailable
                : "Sin vehículos disponibles"}
            </Typography>

            {booking.plate.version &&
              booking.plate.version.infoauto_codia &&
              booking.plate.version.variation && (
                <InfoAutoDialog
                  version={booking.plate.version}
                  model={booking.plate.version.variation}
                />
              )}

            {booking.can_change_plate && booking.id > 0 && (
              <Button
                outline
                className="ml-2"
                theme="accent"
                style={{ height: "fit-content", padding: "0.5rem" }}
                size="sm"
                onClick={() => {
                  setBooking({
                    ...booking,
                    change_plate: !booking.change_plate
                  });
                }}
              >
                <i className="material-icons">edit</i>{" "}
                {booking.change_plate ? "Volver atrás" : "Cambiar vehículo"}
              </Button>
            )}
          </Row>
          <Row>
            {booking.version && (
              <TextField
                id="version_id"
                name="version_id"
                margin="normal"
                disabled
                className="ml-2 mt-2 col-md-4"
                InputLabelProps={{
                  shrink: true
                }}
                value={booking.version.full_name}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Versión</Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              />
            )}
          </Row>
          <Row>
            {booking.vehicleType && (
              <TextField
                id="vehicle_type"
                name="vehicle_type"
                margin="normal"
                disabled
                className="mt-2 col-md-4"
                InputLabelProps={{
                  shrink: true
                }}
                value={
                  booking.vehicleType.name +
                  " - " +
                  booking.vehicleType.hansa_description +
                  " (" +
                  booking.vehicleType.hansa_code +
                  ")"
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Tipo de vehículo
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              />
            )}
            {booking.plate.description && (
              <TextField
                id="booking.plate.description"
                name="booking.plate.description"
                margin="normal"
                disabled
                className="mt-2 ml-2 col-md-4"
                InputLabelProps={{
                  shrink: true
                }}
                value={booking.plate.description}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Vehículo</Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              />
            )}
            {booking.plate.year && (
              <TextField
                id="booking.plate.year"
                name="booking.plate.year"
                margin="normal"
                disabled
                className="mt-2 ml-2 col-md-2"
                InputLabelProps={{
                  shrink: true
                }}
                value={booking.plate.year}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Año</Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              />
            )}
            {booking.plate.vehicle_color && booking.plate.vehicle_color.name && (
              <TextField
                id="booking.plate.color"
                name="booking.plate.color"
                margin="normal"
                disabled
                className="mt-2 ml-2 col-md-2"
                InputLabelProps={{
                  shrink: true
                }}
                value={booking.plate.vehicle_color.name}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Color</Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              />
            )}
            {booking.plate.insurance &&
              booking.plate.insurance.franchise_ammount && (
                <TextField
                  id="booking.plate.franchise"
                  name="booking.plate.franchise"
                  margin="normal"
                  disabled
                  className="mt-2 col-md-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={"$" + booking.plate.insurance.franchise_ammount}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">
                          Franquicia seguro
                        </Typography>
                      </InputAdornment>
                    ),
                    style: { fontSize: "0.75rem" }
                  }}
                />
              )}
          </Row>
          <Row className="px-2">
            <FormControl
              required
              className="col-md-12"
              inputProps={{ shrink: true }}
              style={{ width: "100%" }}
            >
              <Typography variant="caption" style={{ color: "#000" }}>
                Descripción
              </Typography>
              <ReactQuill
                theme="snow"
                style={{ width: "100%", backgroundColor: "#fff" }}
                className="my-2"
                value={booking.description ? booking.description : ""}
                onChange={content => {
                  setBooking({
                    ...booking,
                    description: content
                  });
                }}
              />
            </FormControl>
          </Row>
          <Row className="px-2">
            <Typography variant="body1" className="mt-2 col-12 px-0">
              Cliente
            </Typography>
            {booking.id == 0 ? (
              <Autocomplete
                id={"clients"}
                name={"clients"}
                getOptionLabel={option => option.business_name}
                getOptionSelected={(option, value) =>
                  option.business_name === value
                }
                renderOption={option => (
                  <Typography variant="caption">
                    {option.business_name}
                  </Typography>
                )}
                options={clients.options}
                loading={clients.loading}
                onInputChange={handleClientSearch}
                onChange={(e, value) => {
                  if (value) {
                    setBooking({
                      ...booking,
                      client_id: value.id
                    });
                    if (
                      value.contact &&
                      value.contact.subcontacts &&
                      value.contact.subcontacts.length > 0
                    ) {
                      setSubcotacts(value.contact.subcontacts);
                    }
                  }
                }}
                autoComplete
                noOptionsText={
                  <Typography variant="caption">Sin resultados</Typography>
                }
                includeInputInList
                className="mt-2 col-md-3 px-0"
                renderInput={params => (
                  <TextField
                    {...params}
                    placeholder="Ingrese un cliente"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {vehicles.loading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      )
                    }}
                    InputLabelProps={{
                      ...params.InputLabelProps,
                      shrink: true
                    }}
                    inputProps={{
                      ...params.inputProps,
                      style: { fontSize: "0.75rem", width: 230 }
                    }}
                  />
                )}
              />
            ) : (
              <TextField
                id="client.business_name"
                name="client.business_name"
                margin="normal"
                disabled
                className="mt-2 col-md-3"
                InputLabelProps={{
                  shrink: true
                }}
                value={booking.client.business_name}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Cliente</Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              />
            )}
            {clientContracts && clientContracts.length > 0 && (
              <TextField
                id="contract_id"
                name="contract_id"
                select
                margin="normal"
                className="mt-2 ml-2 col-md-3"
                InputLabelProps={{
                  shrink: true
                }}
                onChange={e => {
                  setBooking({
                    ...booking,
                    contract_id: e.target.value
                  });
                }}
                value={booking.contract_id}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Contrato</Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {clientContracts.map(option => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option.name} {option.hansa_start_date} -{" "}
                    {option.hansa_end_date}
                  </MenuItem>
                ))}
              </TextField>
            )}
            {clientStructures && clientStructures.length > 0 && (
              <TextField
                id="client_structure_id"
                name="client_structure_id"
                select
                margin="normal"
                className="mt-2 ml-2 col-md-3"
                InputLabelProps={{
                  shrink: true
                }}
                onChange={e => {
                  setBooking({
                    ...booking,
                    client_structure_id: e.target.value
                  });
                }}
                value={booking.client_structure_id}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Centro de costos/Sector
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {clientStructures.map(option => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option.code} {option.name}
                  </MenuItem>
                ))}
              </TextField>
            )}
            <TextField
              id="purchase_order"
              name="purchase_order"
              margin="normal"
              className="mt-2 ml-2 col-md-3"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setBooking({
                  ...booking,
                  purchase_order: e.target.value
                });
              }}
              value={booking.purchase_order}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Orden de compra</Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
          </Row>
          <Row>
            {booking.id == 0 && subcontacts && subcontacts.length > 0 && (
              <>
                <Autocomplete
                  className="mt-2 ml-2"
                  id="subcontact_id"
                  style={{ width: 225 }}
                  getOptionLabel={option =>
                    option.firstname + " " + option.lastname
                  }
                  getOptionSelected={(option, value) =>
                    option.firstname === value
                  }
                  renderOption={option => (
                    <Typography variant="caption">
                      {option.firstname} {option.lastname}
                    </Typography>
                  )}
                  options={subcontacts}
                  onChange={(e, value) => {
                    if (value) {
                      setBooking({
                        ...booking,
                        subcontact_id: value.id
                      });
                    }
                  }}
                  autoComplete
                  noOptionsText={
                    <Typography variant="caption">Sin resultados</Typography>
                  }
                  name="subcontact_id"
                  includeInputInList
                  renderInput={params => (
                    <TextField
                      {...params}
                      placeholder="Conductor"
                      id="subcontact_id"
                      name="subcontact_id"
                      autoComplete="off"
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {subcontacts.loading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        )
                      }}
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "contact_name",
                        style: { fontSize: "0.75rem", width: 225 }
                      }}
                    />
                  )}
                />
                {!showNewContact ? (
                  <PersonAddDisabledIcon
                    className="mt-2"
                    onClick={e => setShowNewContact(true)}
                  />
                ) : (
                  <PersonAddIcon
                    className="mt-2"
                    onClick={e => setShowNewContact(false)}
                  />
                )}
              </>
            )}
            {showNewContact && (
              <Row className="px-2">
                <TextField
                  id="subcontact.email"
                  name="subcontact.email"
                  margin="normal"
                  className="mt-2 ml-2 col-md-3"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={booking.subcontact.email}
                  onChange={e => {
                    setBooking({
                      ...booking,
                      subcontact: {
                        ...booking.subcontact,
                        email: e.target.value
                      }
                    });
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Email</Typography>
                      </InputAdornment>
                    ),
                    style: { fontSize: "0.75rem" }
                  }}
                />
                <TextField
                  id="subcontact.phone"
                  name="subcontact.phone"
                  margin="normal"
                  className="mt-2 ml-2 col-md-3"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={booking.subcontact.phone}
                  onChange={e => {
                    setBooking({
                      ...booking,
                      subcontact: {
                        ...booking.subcontact,
                        phone: e.target.value
                      }
                    });
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Teléfono</Typography>
                      </InputAdornment>
                    ),
                    style: { fontSize: "0.75rem" }
                  }}
                />
                <TextField
                  id="subcontact.firstname"
                  name="subcontact.firstname"
                  margin="normal"
                  className="mt-2 ml-2 col-md-3"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={booking.subcontact.firstname}
                  onChange={e => {
                    setBooking({
                      ...booking,
                      subcontact: {
                        ...booking.subcontact,
                        firstname: e.target.value
                      }
                    });
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Nombre</Typography>
                      </InputAdornment>
                    ),
                    style: { fontSize: "0.75rem" }
                  }}
                />
                <TextField
                  id="subcontact.lastname"
                  name="subcontact.lastname"
                  margin="normal"
                  className="mt-2 ml-2 col-md-3"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={booking.subcontact.lastname}
                  onChange={e => {
                    setBooking({
                      ...booking,
                      subcontact: {
                        ...booking.subcontact,
                        lastname: e.target.value
                      }
                    });
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Apellido</Typography>
                      </InputAdornment>
                    ),
                    style: { fontSize: "0.75rem" }
                  }}
                />
              </Row>
            )}
            {booking.id > 0 && subcontacts && subcontacts.length > 0 && (
              <TextField
                id="subcontact_id"
                name="subcontact_id"
                select
                margin="normal"
                className="mt-2 ml-2 col-md-3"
                InputLabelProps={{
                  shrink: true
                }}
                onChange={e => {
                  setBooking({
                    ...booking,
                    subcontact_id: e.target.value
                  });
                }}
                value={booking.subcontact_id}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Contacto</Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {subcontacts.map(option => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option.firstname} {option.lastname}
                  </MenuItem>
                ))}
              </TextField>
            )}
            {!showNewContact &&
              booking.subcontact &&
              booking.subcontact.contact && (
                <>
                  <TextField
                    id="subcontact.email"
                    name="subcontact.email"
                    margin="normal"
                    disabled
                    className="mt-2 ml-2 col-md-3"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={booking.subcontact.contact.email}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Email</Typography>
                        </InputAdornment>
                      ),
                      style: { fontSize: "0.75rem" }
                    }}
                  />
                  <TextField
                    id="subcontact.phone"
                    name="subcontact.phone"
                    margin="normal"
                    disabled
                    className="mt-2 ml-2 col-md-3"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={booking.subcontact.contact.phone}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Teléfono</Typography>
                        </InputAdornment>
                      ),
                      style: { fontSize: "0.75rem" }
                    }}
                  />
                </>
              )}
            <TextField
              name="contact_document_number"
              id="contact_document_number"
              margin="normal"
              className="mt-2 ml-2 col-md-3"
              InputLabelProps={{
                shrink: true
              }}
              value={booking.contact_document_number}
              onChange={e => {
                setBooking({
                  ...booking,
                  contact_document_number: e.target.value
                });
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">DNI</Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
          </Row>

          {booking.id > 0 && (
            <Row className="px-2">
              <Typography variant="body1" className="mt-2 col-12 px-0">
                Muleto
              </Typography>
              {booking.id > 0 && booking.status == "alquilada" ? (
                <Autocomplete
                  id={"related_vehicles"}
                  name={"related_vehicles"}
                  value={booking.relatedPlate}
                  getOptionLabel={option => option.plate}
                  getOptionSelected={(option, value) => option.plate === value}
                  renderOption={option => (
                    <Typography variant="caption">
                      {option.plate} {option.description}
                    </Typography>
                  )}
                  options={vehicles.options}
                  loading={vehicles.loading}
                  onInputChange={handleRelatedVehicleSearch}
                  onChange={(e, value) => {
                    if (value) {
                      setBooking({
                        ...booking,
                        related_vehicle_id: value.id,
                        relatedPlate: value
                      });
                    }
                  }}
                  autoComplete
                  noOptionsText={
                    <Typography variant="caption">Sin resultados</Typography>
                  }
                  includeInputInList
                  className="mt-2 col-md-3 p-0"
                  renderInput={params => (
                    <TextField
                      {...params}
                      placeholder={
                        searchByPlate
                          ? `Ingrese una patente`
                          : `Ingrese por tipo de renting o marca modelo`
                      }
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {vehicles.loading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        )
                      }}
                      InputLabelProps={{
                        ...params.InputLabelProps,
                        shrink: true
                      }}
                      inputProps={{
                        ...params.inputProps,
                        style: { fontSize: "0.75rem", width: 230 }
                      }}
                    />
                  )}
                />
              ) : (
                booking.relatedPlate && (
                  <>
                    <TextField
                      id="relatedPlate.plate"
                      name="relatedPlate.plate"
                      margin="normal"
                      disabled
                      className="mt-2 col-md-4"
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={booking.relatedPlate.plate}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography variant="caption">Muleto</Typography>
                          </InputAdornment>
                        ),
                        style: { fontSize: "0.75rem" }
                      }}
                    />
                    <TextField
                      id="relatedPlate.description"
                      name="relatedPlate.description"
                      margin="normal"
                      disabled
                      className="mt-2 col-md-3"
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={booking.relatedPlate.description}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography variant="caption">Muleto</Typography>
                          </InputAdornment>
                        ),
                        style: { fontSize: "0.75rem" }
                      }}
                    />
                  </>
                )
              )}
            </Row>
          )}
          <Row className="px-2">
            <Typography variant="body1" className="mt-2 col-12 px-0">
              Seguimiento Kilometraje
            </Typography>
            <TextField
              id="initial_km"
              name="initial_km"
              type="number"
              margin="normal"
              className="mr-2 mt-1 col-md-2"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setBooking({
                  ...booking,
                  initial_km: e.target.value,
                  km_price: parseInt(booking.total_price / e.target.value)
                });
              }}
              value={booking.initial_km}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Km Inicial</Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
            <TextField
              id="last_km"
              name="last_km"
              type="number"
              margin="normal"
              className="mr-2 mt-1 col-md-2"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setBooking({
                  ...booking,
                  last_km: e.target.value
                });
              }}
              value={booking.last_km}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Km Final</Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
          </Row>
          <Row>
            <TextField
              id="km_done"
              name="km_done"
              type="number"
              disabled
              margin="normal"
              className="mr-2 mt-1 col-md-2"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setBooking({
                  ...booking,
                  km_done: e.target.value
                });
              }}
              value={booking.km_done}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Km Realizados</Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
            <TextField
              id="km_excess"
              name="km_excess"
              type="number"
              disabled
              margin="normal"
              className="mr-2 mt-1 col-md-2"
              InputLabelProps={{
                shrink: true
              }}
              value={booking.km_excess}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Km Excedente</Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
            <NumberFormat
              id="km_excess_price"
              disabled
              name="km_excess_price"
              value={booking.km_excess_price}
              className="mr-2 mt-1 col-md-3"
              InputProps={{
                style: { fontSize: "0.75rem" },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Excedente Total</Typography>
                  </InputAdornment>
                )
              }}
              thousandSeparator=","
              decimalSeparator="."
              prefix={"$"}
              customInput={TextField}
              InputLabelProps={{
                shrink: true
              }}
            />
          </Row>
          <Row className="px-2">
            <Typography variant="body1" className="mt-2 col-12 px-0">
              Fechas
            </Typography>
            <TextField
              id="start_date"
              name="start_date"
              type="date"
              margin="normal"
              className="mr-2 mt-1 col-md-4"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setBooking({
                  ...booking,
                  start_date: e.target.value
                });
              }}
              value={booking.start_date}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Inicio reserva</Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
            {booking.id == 0 && (
              <TextField
                id="end_date_calculate"
                name="end_date_calculate"
                disabled={!booking.start_date}
                margin="normal"
                className="mr-2 mt-1 col-md-2"
                InputLabelProps={{
                  shrink: true
                }}
                select
                onChange={e => {
                  const start_date = new Date(booking.start_date);
                  const start_date_month = start_date.getMonth();
                  const start_date_year = start_date.getFullYear();
                  const start_date_day = start_date.getDate();
                  const extraMonths = e.target.value;
                  // if start_date_month + extramonths is grater than 12, add a year to start_date_year
                  const end_date_month =
                    start_date_month + parseInt(extraMonths) > 12
                      ? start_date_month + parseInt(extraMonths) - 12
                      : start_date_month + parseInt(extraMonths);
                  const end_date_year =
                    start_date_month + parseInt(extraMonths) > 12
                      ? start_date_year + 1
                      : start_date_year;
                  const end_date_day = start_date_day;
                  const end_date = new Date(
                    end_date_year,
                    end_date_month,
                    end_date_day
                  );
                  const end_date_string = end_date.toISOString().split("T")[0];
                  setBooking({
                    ...booking,
                    end_date: end_date_string
                  });
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Cantidad meses</Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {qMonths.map(option => (
                  <MenuItem
                    key={option.id}
                    value={option.months}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            )}
            <TextField
              id="end_date"
              name="end_date"
              type="date"
              margin="normal"
              className="mr-2 mt-1 col-md-4"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setBooking({
                  ...booking,
                  end_date: e.target.value
                });
              }}
              value={booking.end_date}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Fin reserva</Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
          </Row>
          <Row className="px-2">
            <TextField
              id="expected_pickup_date"
              name="expected_pickup_date"
              type="datetime-local"
              disabled={userHasRole("commercial") ? false : true}
              margin="normal"
              className="mr-2 mt-1 col-md-4"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setBooking({
                  ...booking,
                  expected_pickup_date: e.target.value
                });
              }}
              value={booking.expected_pickup_date}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">
                      Fecha Entrega Estimada
                    </Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />

            <TextField
              id="expected_dropoff_date"
              name="expected_dropoff_date"
              type="datetime-local"
              disabled={userHasRole("commercial") ? false : true}
              margin="normal"
              className="mr-2 mt-1 col-md-4"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setBooking({
                  ...booking,
                  expected_dropoff_date: e.target.value
                });
              }}
              value={booking.expected_dropoff_date}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">
                      Fecha Recepción Estimada
                    </Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
          </Row>
          <Row className="px-2">
            <TextField
              id="actual_pickup_date"
              name="actual_pickup_date"
              type="datetime-local"
              margin="normal"
              disabled={userHasRole("ops") ? false : true}
              className="mr-2 mt-1 col-md-4"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setBooking({
                  ...booking,
                  actual_pickup_date: e.target.value
                });
              }}
              value={booking.actual_pickup_date}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">
                      Fecha Entrega Real
                    </Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
            <TextField
              id="actual_dropoff_date"
              name="actual_dropoff_date"
              type="datetime-local"
              disabled={userHasRole("ops") ? false : true}
              margin="normal"
              className="mr-2 mt-1 col-md-4"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setBooking({
                  ...booking,
                  actual_dropoff_date: e.target.value
                });
              }}
              value={booking.actual_dropoff_date}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">
                      Fecha Recepción Real
                    </Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
          </Row>
          <Row className="px-2">
            <Typography variant="body1" className="mt-2 col-12 px-0">
              Cotización
            </Typography>
            <NumberFormat
              id="km_price"
              disabled
              name="km_price"
              value={booking.km_price}
              className="mr-2 mt-1"
              InputProps={{
                style: { fontSize: "0.75rem" },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Precio km</Typography>
                  </InputAdornment>
                )
              }}
              thousandSeparator=","
              decimalSeparator="."
              prefix={"$"}
              customInput={TextField}
              InputLabelProps={{
                shrink: true
              }}
            />

            <TextField
              id="q_km_included"
              name="q_km_included"
              type="number"
              margin="normal"
              className="mr-2 mt-1 col-md-3"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setBooking({
                  ...booking,
                  q_km_included: e.target.value
                });
              }}
              value={booking.q_km_included}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Km incluidos</Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
            <NumberFormat
              id="extra_km_price"
              name="extra_km_price"
              value={booking.extra_km_price}
              onValueChange={values => {
                const { value } = values;
                setBooking({
                  ...booking,
                  extra_km_price: value
                });
              }}
              className="mr-2 mt-1"
              InputProps={{
                style: { fontSize: "0.75rem" },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Precio km extra</Typography>
                  </InputAdornment>
                )
              }}
              thousandSeparator=","
              decimalSeparator="."
              prefix={"$"}
              customInput={TextField}
              InputLabelProps={{
                shrink: true
              }}
            />
            <NumberFormat
              id="extras_price"
              name="extras_price"
              value={booking.extras_price}
              onValueChange={values => {
                const { value } = values;
                setBooking({
                  ...booking,
                  extras_price: value
                });
              }}
              className="mr-2"
              InputProps={{
                style: { fontSize: "0.75rem" },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">
                      Rastreo satelital (pointer mensual)
                    </Typography>
                  </InputAdornment>
                )
              }}
              thousandSeparator=","
              decimalSeparator="."
              prefix={"$"}
              customInput={TextField}
              InputLabelProps={{
                shrink: true
              }}
            />
            <NumberFormat
              id="toll_price"
              name="toll_price"
              value={booking.toll_price}
              onValueChange={values => {
                const { value } = values;
                setBooking({
                  ...booking,
                  toll_price: value
                });
              }}
              className="mr-2"
              InputProps={{
                style: { fontSize: "0.75rem" },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Precio peaje</Typography>
                  </InputAdornment>
                )
              }}
              thousandSeparator=","
              decimalSeparator="."
              prefix={"$"}
              customInput={TextField}
              InputLabelProps={{
                shrink: true
              }}
            />            
            <NumberFormat
              id="total_price"
              name="total_price"
              value={booking.total_price}
              onValueChange={values => {
                const { value } = values;
                setBooking({
                  ...booking,
                  total_price: value,
                  km_price: parseInt(value / booking.q_km_included)
                });
              }}
              className="mr-2"
              InputProps={{
                style: { fontSize: "0.75rem" },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Precio total</Typography>
                  </InputAdornment>
                )
              }}
              thousandSeparator=","
              decimalSeparator="."
              prefix={"$"}
              customInput={TextField}
              InputLabelProps={{
                shrink: true
              }}
            />
            <NumberFormat
              id="franchise"
              name="franchise"
              value={booking.franchise}
              onValueChange={values => {
                const { value } = values;
                setBooking({
                  ...booking,
                  franchise: value
                });
              }}
              className="mr-2"
              InputProps={{
                style: { fontSize: "0.75rem" },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">
                      Franquicia alquiler
                    </Typography>
                  </InputAdornment>
                )
              }}
              thousandSeparator=","
              decimalSeparator="."
              prefix={"$"}
              customInput={TextField}
              InputLabelProps={{
                shrink: true
              }}
            />
            <TextField
              id="billing_period"
              name="billing_period"
              margin="normal"
              className="mr-2 mt-1 col-md-3"
              InputLabelProps={{
                shrink: true
              }}
              select
              onChange={e => {
                setBooking({
                  ...booking,
                  billing_period: e.target.value
                });
              }}
              value={booking.billing_period}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">
                      Periodo facturación
                    </Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            >
              {billingPeriods.map(option => (
                <MenuItem
                  key={option}
                  value={option}
                  style={{ fontSize: "0.75rem" }}
                >
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Row>

          {booking.id == 0 && (
            <Row>
              <Typography
                variant="body1"
                className="mt-2 ml-2 col-12 px-0"
                style={{ fontSize: "0.75rem" }}
              >
                Adjuntar cotización
              </Typography>

              <MediaFile
                onChange={handleUploadFile}
                title="Agregar archivo"
                width={"15rem"}
                height={"2rem"}
                acceptedFiles={[".pdf"]}
              />
            </Row>
          )}

          <Row className={"my-2 px-2"}>
            {booking.status != "cancelada" && booking.status != "finalizada" && (
              <Col lg={2} className={"px-0"}>
                <Button
                  primary
                  disabled={loading}
                  theme="accent"
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  <b>GUARDAR</b>
                </Button>
              </Col>
            )}
            <Col lg={2} className={"px-0"}>
              <Button
                outline
                secondary
                theme="accent"
                onClick={() => {
                  window.location.href = "/bookings";
                }}
              >
                <b>VOLVER</b>
              </Button>
            </Col>
          </Row>
        </Col>
        {booking.id > 0 && (
          <Col lg={3} style={{ fontSize: "14px" }}>
            <Card className="mb-2">
              <CardBody className="p-0">
                <ListGroup flush>
                  {booking.booking_quote_id && (
                    <ListGroupItem className="px-3 py-2">
                      <a
                        href={`/bookings/quote/${booking.booking_quote_id}`}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <i className="material-icons mr-1">flag</i>
                        Cotaización: {booking.booking_quote_id}
                      </a>
                    </ListGroupItem>
                  )}
                  <ListGroupItem className="px-3 py-2">
                    <i className="material-icons mr-1">flag</i>
                    Estado: {booking.status}
                  </ListGroupItem>
                  <ListGroupItem className="px-3 py-2">
                    <i className="material-icons mr-1">calendar_today</i>
                    {booking.start_date}{" "}
                    {booking.end_date ? " - " + booking.end_date : ""}
                  </ListGroupItem>
                  <ListGroupItem className="px-3 py-2">
                    <i className="material-icons mr-1">description</i>
                    Tipo reserva: {booking.type ? booking.type.description : ""}
                  </ListGroupItem>
                  <ListGroupItem className=" px-3 py-2">
                    {booking.transitions.length > 0 && "Cambiar a:"}
                    <div className="d-flex">
                      {booking.transitions.length > 0 &&
                        booking.transitions.map((transition, index) => (
                          <Button
                            className="mr-2"
                            disabled={saving}
                            outline
                            key={index}
                            theme="accent"
                            size="sm"
                            onClick={() => {
                              doTransition(transition.state);
                            }}
                          >
                            {transition.transition[0].toUpperCase()}
                          </Button>
                        ))}
                    </div>
                  </ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>

            <Card className="mb-2">
              <CardBody className="p-0">
                <ListGroup flush>
                  <ListGroupItem className="px-3 py-2">
                    <i className="material-icons mr-1">payments</i>
                    Periodo de facturación: {booking.billing_period}
                  </ListGroupItem>
                  <ListGroupItem className="px-3 py-2">
                    <i className="material-icons mr-1">payments</i>
                    Próxima factura: {booking.next_billing_date}
                  </ListGroupItem>
                  <ListGroupItem className="px-3 py-2">
                    <i className="material-icons mr-1">payments</i>
                    Última factura: {booking.last_biling}
                  </ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>

            <Card className="mb-2">
              <CardHeader
                className="border-bottom py-2 px-3"
                onClick={() => setShowBookingWorkOrders(!showBookingWorkOrders)}
              >
                <h6 className="m-0">
                  Ordenes de trabajo
                  <i className="material-icons mr-1">
                    {showBookingWorkOrders
                      ? "keyboard_arrow_up"
                      : "keyboard_arrow_down"}
                  </i>
                </h6>
              </CardHeader>
              {showBookingWorkOrders && (
                <CardBody className="p-0">
                  <ListGroup flush>
                    {booking.work_orders &&
                      booking.work_orders.map((wo, index) => (
                        <ListGroupItem
                          key={index}
                          className="px-3 py-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            window.open("/work-order/" + wo.id, "_blank");
                          }}
                        >
                          <i
                            className={`material-icons mr-1`}
                            style={{
                              color:
                                wo.state == "cerrada" ||
                                wo.state == "finalizada"
                                  ? "red"
                                  : "green"
                            }}
                          >
                            flag
                          </i>
                          {wo.reason} - {wo.type_name} ({wo.id})
                        </ListGroupItem>
                      ))}
                    <ListGroupItem>
                      <InputGroup className="mb-3">
                        <InputGroupAddon type="prepend">
                          <Button
                            outline
                            theme="accent"
                            size="sm"
                            //disabled={!workOrderType}
                            onClick={() => {
                              handleCreateWorkOrder();
                            }}
                          >
                            Nueva OT
                          </Button>
                        </InputGroupAddon>
                        <FormSelect
                          id="work_order_type"
                          name="work_order_type"
                          onChange={e => {
                            setWorkOrderType(e.target.value);
                          }}
                          value={workOrderType}
                        >
                          <option>Seleccione un tipo</option>
                          {workOrderTypes.map((type, index) => (
                            <option
                              key={index}
                              value={type.name}
                              onClick={() => {
                                setWorkOrderType(type.name);
                              }}
                            >
                              {type.name}
                            </option>
                          ))}
                        </FormSelect>
                      </InputGroup>
                    </ListGroupItem>
                  </ListGroup>
                </CardBody>
              )}
            </Card>

            <Card className="mb-2">
              <CardHeader
                className="border-bottom py-2 px-3"
                onClick={() => setShowBookingRelations(!showBookingRelations)}
              >
                <h6 className="m-0">
                  Relaciones
                  <i className="material-icons mr-1">
                    {showBookingRelations
                      ? "keyboard_arrow_up"
                      : "keyboard_arrow_down"}
                  </i>
                </h6>
              </CardHeader>
              {showBookingRelations && (
                <CardBody className="p-0">
                  <ListGroup flush>
                    {booking.relations &&
                      booking.relations.map((item, index) => (
                        <ListGroupItem
                          key={index}
                          className="px-3 py-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            window.open("/booking/" + item.related_booking_id);
                          }}
                        >
                          <i className="material-icons mr-1">attachment</i>
                          {item.type}: {item.related_booking_id}
                        </ListGroupItem>
                      ))}
                  </ListGroup>
                  {booking.relations.length === 0 && (
                    <ListGroup flush>
                      <ListGroupItem>
                        <TextField
                          id="relation_type"
                          className="col-md-8"
                          name="relation_type"
                          onChange={e => {
                            setRelatedBooking({
                              ...relatedBooking,
                              type: e.target.value
                            });
                          }}
                          value={relatedBooking.type}
                          select
                          margin="normal"
                          InputLabelProps={{
                            shrink: true
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Typography variant="caption">
                                  Relación
                                </Typography>
                              </InputAdornment>
                            ),
                            style: { fontSize: "0.75rem" }
                          }}
                        >
                          {relationTypes.map((type, index) => (
                            <option key={index} value={type}>
                              {type}
                            </option>
                          ))}
                        </TextField>

                        <TextField
                          id="related_booking_id"
                          name="related_booking_id"
                          type="number"
                          margin="normal"
                          className="col-md-4"
                          InputLabelProps={{
                            shrink: true
                          }}
                          onChange={e => {
                            setRelatedBooking({
                              ...relatedBooking,
                              related_booking_id: e.target.value
                            });
                          }}
                          value={relatedBooking.related_booking_id}
                          InputProps={{
                            style: { fontSize: "0.75rem" }
                          }}
                        />
                        {booking.status != "finalizada" && (
                          <Button
                            outline
                            theme="accent"
                            size="sm"
                            onClick={() => {
                              handleCreateRelation();
                            }}
                          >
                            Guardar
                          </Button>
                        )}
                      </ListGroupItem>
                    </ListGroup>
                  )}
                </CardBody>
              )}
            </Card>
            <Card className="mb-2">
              <CardHeader
                className="border-bottom py-2 px-3"
                onClick={() => setShowBookingBillings(!showBookingBillings)}
              >
                <h6 className="m-0">
                  Facturas
                  <i className="material-icons mr-1">
                    {showBookingBillings
                      ? "keyboard_arrow_up"
                      : "keyboard_arrow_down"}
                  </i>
                </h6>
              </CardHeader>
              {showBookingBillings && (
                <CardBody className="p-0">
                  <ListGroup flush>
                    {booking.billings &&
                      booking.billings
                        .slice(0, 5)
                        .map((item, index) => (
                          <ListGroupItem
                            key={index}
                            className="px-3 py-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              window.open(
                                "/invoice/" + item.invoice_id,
                                "_blank"
                              );
                            }}
                          >
                            <i className="material-icons mr-1">attach_money</i>
                            {item.invoice ? item.invoice.number : ""}
                            <p className="mb-0">
                              {item.invoice
                                ? "$" +
                                  item.invoice.total_price +
                                  " - " +
                                  item.invoice.date
                                : ""}
                            </p>
                          </ListGroupItem>
                        ))}
                  </ListGroup>
                  <ListGroup flush>
                    <ListGroupItem>
                      <Link
                        onClick={() => {
                          window.open(
                            "/invoices/" + booking.client_id,
                            "_blank"
                          );
                        }}
                      >
                        Ver todas
                      </Link>
                    </ListGroupItem>
                  </ListGroup>
                </CardBody>
              )}
            </Card>
            <Card className="mb-2">
              <CardHeader
                className="border-bottom py-2 px-3"
                onClick={() => setShowBookingTelepaseTolls(!showBookingTelepaseTolls)}
              >
                <h6 className="m-0">
                  Pasadas Peaje
                  <i className="material-icons mr-1">
                    {showBookingTelepaseTolls
                      ? "keyboard_arrow_up"
                      : "keyboard_arrow_down"}
                  </i>
                </h6>
              </CardHeader>
              {showBookingTelepaseTolls && (
                <CardBody className="p-0">
                  <ListGroup flush>
                    {bookingTelepaseTolls &&
                      Object.keys(bookingTelepaseTolls).map((key) => (
                        <ListGroupItem
                          key={key}
                          className="px-3 py-2"
                        >
                          {key} - ${bookingTelepaseTolls[key].toFixed(2)}
                        </ListGroupItem>
                      ))}
                  </ListGroup>
                  <Button
                    outline
                    className="mx-2  justify-content-end mt-2"
                    theme="accent"
                    size="sm"
                    onClick={() => {
                      window.open(
                        "/booking-telepase-tolls/" + booking.id,
                        "_blank"
                      );
                    }}
                  >
                    Ver detalle
                  </Button>
                  
                </CardBody>
              )}
            </Card>            
            <Card className="mb-2">
              <CardHeader
                className="border-bottom py-2 px-3"
                onClick={() =>
                  setShowBookingAttachments(!showBookingAttachments)
                }
              >
                <h6 className="m-0">
                  Adjuntos
                  <i className="material-icons mr-1">
                    {showBookingAttachments
                      ? "keyboard_arrow_up"
                      : "keyboard_arrow_down"}
                  </i>
                </h6>
              </CardHeader>
              {showBookingAttachments && (
                <CardBody className="p-0">
                  <ListGroup flush>
                    {booking.media &&
                      booking.media.map((item, index) => (
                        <ListGroupItem
                          key={index}
                          className="px-3 py-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            window.open(
                              api.media_download + "/" + item.id,
                              "_blank"
                            );
                          }}
                        >
                          <i className="material-icons mr-1">attachment</i>
                          {item.name}
                        </ListGroupItem>
                      ))}
                  </ListGroup>
                  <ListGroup flush>
                    <ListGroupItem>
                      <MediaFile
                        onChange={handleUploadFile}
                        title="Agregar archivo"
                        width={"15rem"}
                        height={"2rem"}
                      />
                      {fileAttached && (
                        <Button
                          outline
                          theme="accent"
                          size="md"
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          <i className="material-icons">save</i> Guardar
                        </Button>
                      )}
                      <Link
                        onClick={() => {
                          handleExport();
                        }}
                      >
                        Imprimir reserva
                      </Link>
                    </ListGroupItem>
                  </ListGroup>
                </CardBody>
              )}
            </Card>
            <Card>
              <CardHeader
                className="border-bottom py-2 px-3"
                onClick={() => setShowBookingHistory(!showBookingHistory)}
              >
                <h6 className="m-0">
                  Historial
                  <i className="material-icons mr-1">
                    {showBookingHistory
                      ? "keyboard_arrow_up"
                      : "keyboard_arrow_down"}
                  </i>
                </h6>
              </CardHeader>
              {showBookingHistory && (
                <CardBody className="p-0">
                  <ListGroup flush>
                    {booking.history &&
                      booking.history.map((item, index) => (
                        <ListGroupItem key={index} className="px-3 py-2">
                          <i className="material-icons mr-1">flag</i>
                          {item.status_to} - ({item.created_at})
                        </ListGroupItem>
                      ))}
                  </ListGroup>
                </CardBody>
              )}
            </Card>
          </Col>
        )}
      </Row>
    </>
  );
};

export default Booking;
